import React from 'react'
import lottie from 'lottie-web';

class AnimationStage extends React.Component{
  componentDidMount(){
    this.renderVideo()
    this.lastValue = null
    this.isPlaying = false
  }

  renderVideo(){
    const element = document.getElementById('video-holder')
    lottie.setQuality('medium')
    this.animation = lottie.loadAnimation({
      container: element,
      path: this.props.data.path,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      rendererSettings: {
        // viewBoxOnly: false,
        context: element,
        // scaleMode: 'noScale',
        clearCanvas: false,
        progressiveLoad: true,
      }
    })
    this.animation.setSubframe(false)

  }

  updateVideo(scrollValue, type){
    const value = Number(scrollValue)
    if(this.animation){
      this.lastValue = value
      // if(type !== 'advance'){
        this.animation.goToAndStop(value, true)
        this.isPlaying = false
      // } else {
      //   if(this.isPlaying){
      //     return
      //   } else {
      //     this.isPlaying = true
      //     this.animation.play()
      //   }
      // }
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.scrollValue !== this.lastScrollValue){
      this.updateVideo(nextProps.scrollValue, nextProps.playType)
      this.lastScrollValue = Number(nextProps.scrollValue)
    }
  }

  render(){
    const style = {
      'position': 'fixed',
      'pointerEvents': 'none',
      'width': '100%',
      'height': '100%',
      'top': '50%',
      'transform': 'translateY(-50%)',
      'MsTransform': 'translateY(-50%)',
      WebkitTransform: 'translate3d(0, -50%, 0)',
    }
    const videoHolderStyle = {
      height: '100%',
      overflow: 'hidden',
      margin: '0 auto',
    }
    return(
      <div className="scale-for-hd" style={style}>
        <div id="video-holder" style={videoHolderStyle}></div>
      </div>
    )
  }
}

export default AnimationStage



// WEBPACK FOOTER //
// ./src/AnimationStage.js